"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardStates = void 0;
const Language_1 = require("../../lang/Language");
class BoardStates {
    static isPreDeal(s) {
        return s.tag === 'predeal';
    }
    static isDeal(s) {
        return s.tag === 'deal';
    }
    static isFlop(s) {
        return s.tag === 'flop';
    }
    static isTurn(s) {
        return s.tag === 'turn';
    }
    static isRiver(s) {
        return s.tag === 'river';
    }
    static isShowdown(s) {
        return s.tag === 'showdown';
    }
}
exports.BoardStates = BoardStates;
BoardStates.PreDeal = {
    tag: 'predeal',
    description: Language_1.Language.strings.states.board.predeal,
};
BoardStates.Deal = {
    tag: 'deal',
    description: Language_1.Language.strings.states.board.deal,
};
BoardStates.Flop = {
    tag: 'flop',
    description: Language_1.Language.strings.states.board.flop,
};
BoardStates.Turn = {
    tag: 'turn',
    description: Language_1.Language.strings.states.board.turn,
};
BoardStates.River = {
    tag: 'river',
    description: Language_1.Language.strings.states.board.river,
};
BoardStates.Showdown = {
    tag: 'showdown',
    description: Language_1.Language.strings.states.board.showdown,
};
//# sourceMappingURL=BoardState.js.map